'use client';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import { Pagination, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { TemplateLandingACF } from '@/types/post/slug';
import SectionImage from '@/components/(landing)/landing/SectionImage';
import { safeHtmlLinks } from '@/utils/links/safeHref';

type CourseTeachersProps = {
    data: TemplateLandingACF['courseTeachers'];
};

const CourseTeachers: React.FC<CourseTeachersProps> = ({ data }) => {
    const { title, teachersList } = data;

    return (
        <section className='bg-[#eaeaea]'>
            <div className='max-w-5xl mx-auto max-lg:ps-5 py-10 max-lg:pt-5'>
                <SectionImage imageUrl={'/nokhbegan/6-teachers.webp'} imageTitle={'Teachers'} />
                {title && (
                    <h2 className='text-2xl hidden font-bold text-center mb-6 dark:text-primary'>
                        {title}
                    </h2>
                )}
                <Swiper
                    slidesPerView={1.2}
                    spaceBetween={20}
                    breakpoints={{
                        1080: {
                            slidesPerView: 3,
                        },
                    }}
                    pagination={{ clickable: true, dynamicBullets: true }}
                    modules={[Pagination, FreeMode]}
                    freeMode
                    scrollbar={{ hide: true }}
                    autoHeight
                    className='related-posts-swiper !pb-20 mt-10'
                >
                    {teachersList.map((teacher, index) => (
                        <SwiperSlide key={index} className='!h-full'>
                            <div className='bg-white p-5 rounded-3xl h-full flex flex-col items-center relative'>
                                <Image
                                    width={1200}
                                    height={1200}
                                    src={teacher.image.sourceUrl}
                                    alt={teacher.image.title || 'courseTeacherImage'}
                                    className='rounded-full border p-1 box-content size-16 aspect-square object-cover'
                                />
                                <div
                                    className={
                                        'border-b w-full pb-5 border-[#EAEAEA] my-3 flex flex-col gap-y-2'
                                    }
                                >
                                    <h3 className='text-base font-semibold text-center text-primary/80 dark:text-primary'>
                                        {teacher.title}
                                    </h3>
                                    <p className={'text-center text-xs opacity-65'}>
                                        {teacher?.subtitle}
                                    </p>
                                </div>
                                <div
                                    className='prose landingList list-disc font-light lg:prose-li:text-sm prose-li:!text-[12px]'
                                    dangerouslySetInnerHTML={{
                                        __html: safeHtmlLinks(teacher.text),
                                    }}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default CourseTeachers;
